import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import ServicesSlider from "@/pages/services/components/ServicesSlider";
import ServiceCards from "@/components/feature/ServiceCards";

const COMPANY_NAME = "NetBasis International";

const texts = {
  title: "Nuestros Servicios",
  h1Text:
    "Servicios comerciales y técnicos integrales para el éxito sostenible de su negocio. Como socio local experimentado, acompañamos a los fabricantes extranjeros de TIC en el desarrollo de nuevos mercados y ofrecemos soluciones a medida para cada etapa de su expansión.",
  introParagraphs: [
    "En NetBasis International ofrecemos a los fabricantes extranjeros del sector de las telecomunicaciones y la informática una amplia gama de servicios comerciales y técnicos, así como consultoría y capacitación, para apoyarlos de manera rápida y eficiente en su camino hacia nuevos mercados. Nuestro enfoque claro es alcanzar sus objetivos de crecimiento en toda la región económica de habla alemana (región DACH).",
    "Para que pueda encontrar más rápidamente el área de especialización deseada, hemos dividido nuestra oferta en cuatro secciones especializadas:",
    "Si desea involucrarnos activamente en su nuevo negocio y confiarnos la realización de tareas concretas, consulte la sección \"Business Development\" para explorar nuestros diferentes servicios y elegir lo que podemos hacer específicamente por usted. Si prefiere tenernos a su lado como puros asesores, oriéntese hacia \"Consulting\". Si desea contratarnos \"por tiempo limitado\" en una de nuestras áreas de especialidad, simplemente haga clic directamente en \"Interim Management\". O si desea recurrir a nuestro conocimiento con fines exclusivos de capacitación y coaching, visite la sección correspondiente.",
  ],
  sectionTitle:
    "Juntos hacia la excelencia operativa y un éxito de mercado sostenible",
  belowText:
    "Cualquiera que sea su idea, NetBasis International le ayuda a especificar con precisión los objetivos y visiones de su plan de entrada al mercado. Como expertos sectoriales sobre el terreno, le asistimos para revisar continuamente todos los procesos y adaptarlos de manera ágil a los requisitos individuales de los nuevos mercados. En este sentido, no nos consideramos un proveedor de servicios externo, sino colaboradores leales y plenamente integrados en su propio equipo, estrechamente vinculados a su proyecto. Poseemos la fina intuición y la sólida experiencia en los mecanismos del mercado local que son absolutamente indispensables para hacer de su proyecto en el extranjero un éxito real y duradero. Gracias a este profundo compromiso y a nuestra clara orientación hacia resultados medibles, consolidamos paso a paso su presencia sólida y altamente competitiva en el mercado.",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

const cardTexts = {
  titles: [
    "Desarrollo de negocio",
    "Consultoría",
    "Interim Management",
    "Formación y coaching",
  ],
  descriptions: [
    "¿Busca apoyo activo y desea delegar tareas operativas de forma sencilla? Entonces elija entre nuestros servicios.",
    "¿Desea contar con nosotros puramente como asesores a su lado? Entonces consulte nuestro catálogo de servicios.",
    "¿Quiere contratarnos \"de forma temporal\" en una de nuestras áreas? Entonces encuentre todos los detalles aquí.",
    "¿Le gustaría aprovechar nuestro conocimiento para fines de capacitación y/o coaching? Entonces eche un vistazo aquí.",
  ],
  readMore: "Más información",
};

const renderWithBold = (text: string) => {
  const parts = text ? text.split(COMPANY_NAME) : [];
  return parts.map((part, i) => (
    <span key={i}>
      {part}
      {i < parts.length - 1 && (
        <strong className="text-primary-600">{COMPANY_NAME}</strong>
      )}
    </span>
  ));
};

export default function ServicesEsPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Nuestros Servicios | NetBasis International"
        description="Servicios comerciales y técnicos integrales, consultoría y capacitación para su expansión exitosa en el mercado DACH."
        ogUrl="https://net-basis.net/es/servicios"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <ServicesSlider />

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            {/* WIDGET 1 - Encabezado (h2) */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {texts.title}
            </h2>

            {/* WIDGET 2 - H1: texto introductorio en negrita */}
            <h1 className="text-foreground-950 font-semibold text-sm md:text-base leading-relaxed mb-4">
              {texts.h1Text}
            </h1>

            {/* WIDGET 3 - texto normal */}
            <div className="space-y-4 font-body text-sm md:text-base text-foreground-950 leading-relaxed">
              {texts.introParagraphs.map(
                (text, idx) =>
                  text && (
                    <p key={idx}>{renderWithBold(text)}</p>
                  )
              )}
            </div>
          </div>
        </section>

        {/* Service Cards */}
        <ServiceCards
          namespace="services"
          titleKeys={[]}
          descriptionKeys={[]}
          readMoreKey=""
          texts={cardTexts}
        />

        {/* WIDGET 4 + 5 - h2 verde + párrafo */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {texts.sectionTitle}
            </h2>
            <div className="space-y-4 font-body text-sm md:text-base text-foreground-950 leading-relaxed">
              <p>{renderWithBold(texts.belowText)}</p>
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {texts.claim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}